import { useEffect, useState } from 'react';
import { http } from '../api';

// Carrega imagem protegida (/api/files/...) com o token da sessão e devolve uma URL local.
export function useAuthImage(apiPath) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    if (!apiPath) { setSrc(null); return undefined; }
    let url = null;
    let alive = true;
    http.get(apiPath.replace(/^\/api/, ''), { responseType: 'blob' })
      .then(r => { if (alive) { url = URL.createObjectURL(r.data); setSrc(url); } })
      .catch(() => alive && setSrc(null));
    return () => { alive = false; if (url) URL.revokeObjectURL(url); };
  }, [apiPath]);
  return src;
}
